import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgPlayAnimation = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="153"
        width="153"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 153 153"
    >
        <g filter="url(#filter0_dd_6831_213547)">
            <circle
                cx="76.4611"
                cy="71.4297"
                fill="rgba(0, 0, 0, 0.3)"
                r="60"
            />
            <circle
                cx="76.4612"
                cy="71.4316"
                r="57.8947"
                stroke="rgba(255, 255, 255, 0.9)"
                strokeWidth="4.21053"
            />
            <path
                d="M60.6721 50.3634C60.6721 47.1087 64.2071 45.0847 67.014 46.7322L102.907 67.7996C105.679 69.4268 105.679 73.4349 102.907 75.062L67.014 96.1295C64.2071 97.777 60.6721 95.7529 60.6721 92.4982V50.3634Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
                height="152.922"
                id="filter0_dd_6831_213547"
                width="152.922"
                x="6.67572e-05"
                y="0.000311375"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="5.02979" />
                <feGaussianBlur stdDeviation="8.23056" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0392157 0 0 0 0 0 0 0 0 0 0.301961 0 0 0 0.08 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_6831_213547"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="0.526316" />
                <feGaussianBlur stdDeviation="2.89474" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0392157 0 0 0 0 0 0 0 0 0 0.301961 0 0 0 0.039 0"
                />
                <feBlend
                    in2="effect1_dropShadow_6831_213547"
                    mode="normal"
                    result="effect2_dropShadow_6831_213547"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect2_dropShadow_6831_213547"
                    mode="normal"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export const PlayAnimationIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgPlayAnimation}
        fontSize={fontSize}
    />
);
